import React from 'react';
import { Quote, Star } from 'lucide-react';
import { Card } from './ui/Card';
export function Testimonials() {
  return <section className="py-20 bg-gray-900 text-white relative overflow-hidden" data-id="element-239">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-240">
        <div className="absolute top-10 left-10 w-64 h-64 bg-pink-600 rounded-full blur-3xl" data-id="element-241"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-pink-600 rounded-full blur-3xl" data-id="element-242"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-243">
        <div className="text-center mb-16" data-id="element-244">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4" data-id="element-245">
            Lo que dicen las <span className="text-pink-400" data-id="element-246">Docentes</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-247">
            Colegas que ya transformaron sus clases con el MegaPack.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-248">
          <Card className="bg-white border-gray-200 p-8 relative" data-id="element-249">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-gray-300 opacity-50" aria-hidden="true" data-id="element-250" />
            <div className="flex items-center gap-4 mb-6" data-id="element-251">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-500 to-pink-700 flex items-center justify-center text-xl font-bold text-white" aria-hidden="true" data-id="element-252">
                M
              </div>
              <div data-id="element-253">
                <h3 className="font-bold text-gray-900" data-id="element-254">María L.</h3>
                <p className="text-sm text-gray-600" data-id="element-255">
                  Docente de Danza Primaria
                </p>
              </div>
            </div>
            <p className="text-gray-900 italic leading-relaxed mb-4" data-id="element-256">
              "¡Increíble material! Me salvó el año. Las fichas de Baby Dance
              son súper divertidas y mis nenas de 4 años aprenden sin darse
              cuenta. Lo recomiendo totalmente."
            </p>
            <div className="flex gap-1" role="img" aria-label="5 de 5 estrellas" data-id="element-257">
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-258" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-259" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-260" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-261" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-262" />
            </div>
          </Card>

          <Card className="bg-white border-gray-200 p-8 relative" data-id="element-263">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-gray-300 opacity-50" aria-hidden="true" data-id="element-264" />
            <div className="flex items-center gap-4 mb-6" data-id="element-265">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gray-800 to-black flex items-center justify-center text-xl font-bold text-white" aria-hidden="true" data-id="element-266">
                C
              </div>
              <div data-id="element-267">
                <h3 className="font-bold text-gray-900" data-id="element-268">Carolina R.</h3>
                <p className="text-sm text-gray-600" data-id="element-269">
                  Profesora de Danza Contemporánea
                </p>
              </div>
            </div>
            <p className="text-gray-900 italic leading-relaxed mb-4" data-id="element-270">
              "La sección de Adultos es muy completa. Los ejercicios de
              composición coreográfica están muy bien estructurados paso a paso.
              Excelente inversión."
            </p>
            <div className="flex gap-1" role="img" aria-label="5 de 5 estrellas" data-id="element-271">
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-272" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-273" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-274" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-275" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-276" />
            </div>
          </Card>

          <Card className="bg-white border-gray-200 p-8 relative" data-id="element-277">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-gray-300 opacity-50" aria-hidden="true" data-id="element-278" />
            <div className="flex items-center gap-4 mb-6" data-id="element-279">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-500 to-pink-700 flex items-center justify-center text-xl font-bold text-white" aria-hidden="true" data-id="element-280">
                V
              </div>
              <div data-id="element-281">
                <h3 className="font-bold text-gray-900" data-id="element-282">Valeria P.</h3>
                <p className="text-sm text-gray-600" data-id="element-283">
                  Tallerista Independiente
                </p>
              </div>
            </div>
            <p className="text-gray-900 italic leading-relaxed mb-4" data-id="element-284">
              "Uso los bonos todo el tiempo. El kit de muestras me salvó el
              festival de fin de año. Me permite tener todo organizado y
              mantener el nivel siempre alto."
            </p>
            <div className="flex gap-1" role="img" aria-label="5 de 5 estrellas" data-id="element-285">
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-286" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-287" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-288" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-289" />
              <Star className="w-4 h-4 text-pink-600 fill-pink-600" aria-hidden="true" data-id="element-290" />
            </div>
          </Card>
        </div>
      </div>
    </section>;
}